export const emailJsServiceId = 'service_7o1kejm'
export const emailJsTemplateId = 'template_ix98wjp'
export const emailJsUserId = 'user_uzovRZ1gRMAs4BwRt6wo7'
export const emailTo = 'info@muntramusikanter.fi'
